(function () {
  const root = document.querySelector('[data-candy-product]');
  if (!root) return;

  const main = root.querySelector('#cp-main-img');
  root.querySelectorAll('[data-cp-thumb]').forEach((btn) => {
    btn.addEventListener('click', () => {
      if (main) { main.src = btn.dataset.cpThumb; main.removeAttribute('srcset'); }
      root.querySelectorAll('.cp__thumb').forEach((b) => b.classList.toggle('is-on', b === btn));
    });
  });

  const form = root.querySelector('[data-cp-form]');
  if (!form) return;
  const idInput = form.querySelector('[data-cp-id]');
  const addBtn = form.querySelector('[data-cp-add]');
  const msg = form.querySelector('[data-cp-msg]');
  const qtyInput = form.querySelector('[data-cp-qty-input]');
  const priceEl = root.querySelector('[data-cp-price]');
  const fromEl = root.querySelector('[data-cp-from]');
  const summary = form.querySelector('[data-cp-summary]');
  const sticky = root.querySelector('[data-cp-sticky]');
  const stickyPrice = root.querySelector('[data-cp-sticky-price]');
  const stickyAdd = root.querySelector('[data-cp-sticky-add]');

  function selected() { return form.querySelector('input[name="cp-variant"]:checked'); }
  function qty() { return Math.max(1, Math.min(20, parseInt(qtyInput && qtyInput.value, 10) || 1)); }

  function refresh() {
    const r = selected();
    if (!r) return;
    idInput.value = r.value;
    if (priceEl && r.dataset.was) priceEl.innerHTML = '<span class="visually-hidden visually-hidden--inline">Regular price </span><s class="fd-was">' + r.dataset.was + '</s> <span class="visually-hidden visually-hidden--inline">Sale price </span><strong class="fd-now">' + r.dataset.price + '</strong> <strong class="fd-save">Save ' + r.dataset.save + '</strong>';
    else if (priceEl) priceEl.innerHTML = r.dataset.now ? '<span class="visually-hidden visually-hidden--inline">Regular price </span><s class="fd-was">' + r.dataset.price + '</s> <span class="visually-hidden visually-hidden--inline">Sale price </span><strong class="fd-now">' + r.dataset.now + '</strong>' : r.dataset.price;
    if (fromEl) fromEl.hidden = true;
    const noteEl = root.querySelector('[data-cp-note]');
    if (noteEl && r.dataset.note) noteEl.textContent = r.dataset.note;
    const oz = parseInt(r.dataset.oz, 10) || 0;
    const parts = [];
    if (oz) parts.push(oz + ' oz');
    if (r.dataset.per) parts.push((r.dataset.perNow || r.dataset.per) + '/oz');
    if (summary) summary.textContent = parts.join(' \u00b7 ');
    if (stickyPrice) stickyPrice.textContent = r.dataset.title + ' \u00b7 ' + (r.dataset.now || r.dataset.price);
    // show this size's own photo (and highlight its thumbnail)
    if (main && r.dataset.image) {
      main.src = r.dataset.image;
      main.removeAttribute('srcset');
      root.querySelectorAll('.cp__thumb').forEach((b) => b.classList.toggle('is-on', b.dataset.cpMedia === r.dataset.mediaId));
    }
  }
  // Subscribe & save (only when the product has a "Subscribe & save" selling plan)
  const subBox = form.querySelector('[data-cp-sub]');
  let allocs = {};
  try { const el = form.querySelector('[data-cp-allocs]'); if (el) allocs = JSON.parse(el.textContent); } catch (e) { allocs = {}; }
  const planSel = form.querySelector('[data-cp-plan]');
  const cents = (c) => '$' + (c / 100).toFixed(2).replace(/\.00$/, '');
  function isSub() { const r = form.querySelector('input[name="cp-purchase"]:checked'); return !!(subBox && r && r.value === 'sub'); }
  function refreshSub() {
    if (!subBox) return;
    const r = selected();
    const a = r && allocs[r.value] && allocs[r.value][planSel.value];
    const once = subBox.querySelector('[data-cp-once]');
    const sp = subBox.querySelector('[data-cp-subprice]');
    if (once && r) once.textContent = ' ' + (r.dataset.now || r.dataset.price);
    if (sp) sp.textContent = a ? ' ' + cents(a[0]) + (a[1] > a[0] ? ' (save ' + Math.round((1 - a[0] / a[1]) * 100) + '%)' : '') : '';
    subBox.querySelectorAll('.cp__opt').forEach((l) => l.classList.toggle('is-on', l.querySelector('input').checked));
    subBox.hidden = !a;
  }
  if (subBox) subBox.addEventListener('change', refreshSub);
  form.addEventListener('change', (e) => { if (e.target.name === 'cp-variant') { refresh(); refreshSub(); } });
  refresh();
  refreshSub();

  root.querySelectorAll('[data-cp-qty]').forEach((b) => {
    b.addEventListener('click', () => {
      qtyInput.value = Math.max(1, Math.min(20, qty() + Number(b.dataset.cpQty)));
    });
  });
  if (qtyInput) qtyInput.addEventListener('change', () => { qtyInput.value = qty(); });

  async function add() {
    if (addBtn.disabled) return;
    addBtn.disabled = true;
    const label = addBtn.textContent;
    addBtn.textContent = 'Adding...';
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(isSub() ? { id: Number(idInput.value), quantity: qty(), selling_plan: Number(planSel.value) } : { id: Number(idInput.value), quantity: qty() }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.description || 'Could not add to cart');
      msg.innerHTML = 'Added to your cart. <a href="/cart">View cart</a>';
      msg.hidden = false;
    } catch (err) {
      msg.textContent = err.message || 'Something went wrong, try again.';
      msg.hidden = false;
    } finally {
      addBtn.disabled = false;
      addBtn.textContent = label;
    }
  }
  form.addEventListener('submit', (e) => { e.preventDefault(); add(); });

  // Mobile sticky bar: shows once the main Add to cart scrolls out of view.
  if (sticky && stickyAdd && 'IntersectionObserver' in window) {
    stickyAdd.addEventListener('click', () => { add(); });
    const io = new IntersectionObserver(([entry]) => {
      sticky.hidden = entry.isIntersecting || entry.boundingClientRect.top > 0;
      document.body.classList.toggle('cp-sticky-on', !sticky.hidden);
    });
    io.observe(addBtn);
  }
})();
